
const getFlightSegmentDate = (date) => {
    let formatedDate = new Date(date);
    return formatedDate.toDateString()
};

export default getFlightSegmentDate;